
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.819 0h.334c.387.108.644.393.914.663 2.155 2.159 4.313 4.315 6.47 6.472.064.064.129.128.188.197.376.436.37 1.004-.037 1.412a4037.184 4037.184 0 01-6.944 6.943c-.425.424-1.028.413-1.455-.009a291.18 291.18 0 01-1.261-1.25C4.239 12.641 2.453 10.852.663 9.066.393 8.796.108 8.54 0 8.153v-.335c.125-.204.216-.442.38-.607 1.509-1.526 3.03-3.04 4.548-4.557.052-.052.11-.1.16-.146.038.024.058.032.072.047.548.545 1.098 1.09 1.638 1.643.047.048.06.162.042.235-.127.549.073 1.084.55 1.372.137.082.17.17.169.316a482.168 482.168 0 000 3.888c0 .174-.035.284-.198.384-.465.285-.661.842-.514 1.366a1.25 1.25 0 001.174.903 1.253 1.253 0 001.19-.827 1.216 1.216 0 00-.421-1.396.386.386 0 01-.185-.36c.006-1.268.003-2.536.004-3.804 0-.067.006-.133.011-.213.039.018.06.022.072.034.484.482.97.962 1.445 1.452.046.047.045.163.03.24-.092.458.006.86.345 1.185.343.329.752.439 1.213.305a1.252 1.252 0 00.86-1.474 1.238 1.238 0 00-1.445-.929c-.133.028-.22-.007-.312-.102a67.38 67.38 0 00-1.406-1.402c-.151-.145-.226-.28-.15-.487.028-.073.016-.165.006-.247-.1-.838-.9-1.253-1.493-1.1a.287.287 0 01-.233-.063c-.54-.525-1.067-1.062-1.603-1.59-.097-.096-.1-.159 0-.254.295-.286.581-.58.873-.87.299-.297.565-.637.997-.76z","fill":"#748190"}})])
          )
        }
      }
    